import React from 'react';
import Button from '../../refresh/atoms/button';
import { replaceWithJioCDN } from '../../utils/imageHandling';


function LocalePopUpForUserLocation(props) {
  const { image = '', allowUserLocation, luxe = false, device = 'msite', alt = '', enablePriorityDeliveryPhase2=false } = props;
  return (
    <div className="locale">
      <div className="locale__container">
        {device !== 'msite' && (
          <div className="locale__text">
            <h1 className="locale__header locale__center">Allow us to access Your location</h1>
          </div>
        )}
        <div className="locale__image">
          <img
            src={replaceWithJioCDN(image)}
            alt={alt || 'Location image'}
            width="72"
            height="72"
          />
        </div>
        {device === 'msite' && (
          <div className="locale__text">
            <h1 className="locale__header">Allow Location Access</h1>
            <p className="locale__message">
            { enablePriorityDeliveryPhase2 ? "Your location is safe with us. We use it to provide you the best shopping experience."
              : "We need your location to provide you with the accurate delivery dates for your favourite products. Rest assured, your location is safe with us."}
            </p>
          </div>
        )}
        {device !== 'msite' && (
          <div className="locale__text">
            <p className="locale__message">
              We need your location to provide you with the best experience. Your location is safe
              with us.
            </p>
          </div>
        )}
      </div>
      <div className="refreshBtn">
        <Button
          ariaLabel="Allow Location"
          variant="primary"
          fullWidth
          btnLabel={device === 'msite' ? 'Allow' : 'Allow Location'}
          customClass={luxe ? 'luxe-pr-btn' : ''}
          onClick={allowUserLocation}
        />
      </div>
    </div>
  );
}

export default LocalePopUpForUserLocation;
